import React, {Component} from "react";
import {connect} from "react-redux";
import WidgetOpenAssignments from "./widgets/Widget-OpenAssignments";
import ElasticSearchQuery from "../../../actions/elastic-search-query";
import {RECEIVED_STUDENT_ASSIGNMENT_DASHBOARD_RESULTS,ElasticSearchTypes,
    ElasticSearchColumns} from "../../../actions/types";
import apiClient from "../../../actions/api-client";
import {browserHistory} from "react-router";
import WidgetRegistration from './widgets/Widget-Registration'
import WidgetPractices from './widgets/Widget-Practices';
import WidgetActivityLog from './widgets/Widget-ActivityLog';
import {Button, Modal, Alert} from "react-bootstrap";
import TextFieldGroup from "../../forms/text-field-group";
import {
    CognitoUserPool} from 'amazon-cognito-identity-js';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import config from "../../../config";

class ManageDashboardStudent extends Component {

    constructor(props) {
        super(props);
        this.getAllAssignments =this.getAllAssignments.bind(this);
        this.getAssignmetFilters = this.getAssignmetFilters.bind(this);
        this.onFilterChangeHandler = this.onFilterChangeHandler.bind(this);
        this.getAllSubjects = this.getAllSubjects.bind(this);
        this.getAllActivityLog = this.getAllActivityLog.bind(this);

        this.onChange = this.onChange.bind(this);
        this.getverificationCodeDialog = this.getverificationCodeDialog.bind(this);
        this.verifyUser = this.verifyUser.bind(this);
        this.getCode = this.getCode.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.isValid = this.isValid.bind(this);
        this.getValidationState = this.getValidationState.bind(this);

        this.state={allFilters:[],subjects:[],activityLog:[],
            emailAddressForVerification:'',
            showVerificationCodeDialog:false,
            codeSent:false, errors:{},
            codeForVerification:'', showAlert:false, alertText:'', alertStyle:''};
    }

    componentDidMount()
    {
        this.getAllAssignments();
        this.getAssignmetFilters();
        this.getAllSubjects();
        this.getAllActivityLog();

        if (this.props.location.state) {
            this.setState({ ...this.props.location.state });
        }

        browserHistory.replace({
            pathname: '/student/dashboard',
            state: {}
        });

    }

    getAllActivityLog()
    {
        let context = this;
        let params = {};
        let pathTemplate = '/student/audit/'+this.props.auth.user.userName;
        apiClient.invokeApi(params, pathTemplate, 'GET', {}, {}, '3').then(function (result) {
            context.setState({activityLog: result.data.result});
        }).catch(function (error) {

        });
    }


    getAllAssignments()
    {
        let {dispatch}= this.props;
        let context = this;
        let elasticSearchQuery  = new ElasticSearchQuery();
        elasticSearchQuery.query("stdassign", ElasticSearchColumns.StudentAssignment, this.props,
            "", 50, 1 ,{dueDate:{order: "asc"}}, [], function (results, totalRecords) {

                dispatch({
                    type: RECEIVED_STUDENT_ASSIGNMENT_DASHBOARD_RESULTS,
                    data: JSON.parse(JSON.stringify(results)),
                    totalRecords:totalRecords
                });
            }, true, 'assignmentStatus: (Open OR "Past Due") AND studentID: ("'+context.props.auth.user.userName+'")', 'lp-student/');
    }

    getAssignmetFilters()
    {
        let elasticSearchQuery  = new ElasticSearchQuery();
        let that = this;
        elasticSearchQuery.getFilters("stdassign", ElasticSearchColumns.StudentAssignment,
            this.props, '', {"Teachers":{terms:{field:'teacher', size:100}}}, [], function (results) {

                let allFitlers = results.data[0].allValues;
                allFitlers.sort(function (a,b) {
                    return b.name.localeCompare(a.name)
                });
                allFitlers.splice(0, 0, {id:'All Assignments', name:'All Assignments'});
                that.setState({allFilters: allFitlers});
            }, true, 'studentID: ("'+that.props.auth.user.userName+'")', ElasticSearchTypes.StudentAssignment);
    }

    onFilterChangeHandler(event)
    {
        let filter = event.target.value.toLowerCase() === 'all assignments' ? [] : [{"terms":{"teacher":[event.target.value]}}];
        let {dispatch}= this.props;
        let elasticSearchQuery  = new ElasticSearchQuery();
        elasticSearchQuery.query("stdassign", ElasticSearchColumns.StudentAssignment, this.props,
            '', 50,1, {dueDate:{order: "asc"}}, filter, function (results, totalRecords) {

                dispatch({
                    type: RECEIVED_STUDENT_ASSIGNMENT_DASHBOARD_RESULTS,
                    data: JSON.parse(JSON.stringify(results)),
                    totalRecords:totalRecords
                });
            }, true, 'assignmentStatus: (Open OR "Past Due")  AND studentID: ("'+this.props.auth.user.userName+'")', 'lp-student/');
    }

    getAllSubjects() {
        let context = this;
        let sName = this.props.auth.user.schoolName ? this.props.auth.user.schoolName : 'trial';

        let params = {
            schoolName: sName,
            ownerName: this.props.auth.user.userName,
        };
        let pathTemplate = '/subjects/ownerName/{ownerName}/schoolName/{schoolName}';
        let method = 'GET';
        let additionalParams = {};
        let body = {};
        apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
            context.setState({
                subjects: result.data,
            });
        }).catch(function (error) {

        });
    }

    onChange(event)
    {
        this.setState({[event.target.id] : event.target.value});
    }

    getDialog() {

        return <Modal id="hint_modal"
            show={this.state.showDialog}
            onHide={() => {
                this.setState({ showDialog: false });
            }}
            container={this}
            aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="delete-activity-modal">{this.state.dialogTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {this.state.dialogMessage}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {
                    this.setState({ showDialog: false });
                }} bsStyle='primary'>OK</Button>
            </Modal.Footer>
        </Modal>;
    }
    getverificationCodeDialog()
    {
        let body =
            <div>
                <p>Please enter the code sent via email</p>
                <TextFieldGroup
                    error={this.state.errors.codeForVerification}
                    field="codeForVerification"
                    id="codeForVerification"
                    value={this.state.codeForVerification}
                    placeholder="Enter Code"
                    onChange={this.onChange}
                />
            </div>;

        return <Modal id="welcome_modal"
                      show={this.state.showVerificationCodeDialog}
                      onHide={()=> {
                          this.setState({showVerificationCodeDialog: false});
                      }}
                      container={this}
                      aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <div>
                    <h3>
                        Email Verification
                    </h3>
                </div>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Modal.Footer>
                    <div>
                        <Button className="btn btn-primary crtBtn" onClick={()=> {
                            this.verifyUser()
                        }}>Verify</Button>
                        <Button className="btn btn-primary crtBtn" onClick={()=> {
                            this.getCode();
                        }}>Resend Code</Button>
                    </div>
                </Modal.Footer>
            </Modal.Footer>
        </Modal>;
    }

    handleAlertDismiss() {
        this.setState({'showAlert': false});
    }

    getCode()
    {

        let that = this;
        let userPool = new CognitoUserPool({
            UserPoolId: config.userPoolId,
            ClientId: config.clientId
        });
        let cognitoUser = userPool.getCurrentUser();
        cognitoUser.getSession(function(err, session) {
            if (session) {
                cognitoUser.getAttributeVerificationCode('email',
                    {
                        onSuccess: function (result) {

                        },
                        onFailure: function(err) {
                            that.setState({showVerificationCodeDialog:false, showAlert:true, alertText:'Unable to send code, Please try again later', alertStyle:'danger'});
                            setTimeout(()=>{
                                that.setState({ showAlert: false});
                            }, 5000);
                        },
                        inputVerificationCode: null
                    });
            }
        });
    }
    getValidationState()
    {
        let errors = {};

        if (Validator.isEmpty(this.state.codeForVerification))
        {
            errors.codeForVerification = 'This field is required';
        }
        if (this.state.codeForVerification.trim().indexOf(" ")>-1) {
            errors.codeForVerification = 'The code cannot contain spaces';
        }
        if (this.state.codeForVerification.search(/[!@#$%^&*]/) > -1) {
            errors.codeForVerification ='Special characters are not allowed in the code';
        }

        return {
            errors,
            isValid: isEmpty(errors)
        }
    }
    isValid()
    {
        const {errors, isValid} = this.getValidationState();
        if (!isValid) {
            this.setState({errors});
        }
        return isValid;
    }

    verifyUser()
    {
        if (this.isValid()) {

            const {dispatch} = this.props;
            let that = this;
            let userPool = new CognitoUserPool({
                UserPoolId: config.userPoolId,
                ClientId: config.clientId
            });
            let cognitoUser = userPool.getCurrentUser();
            cognitoUser.getSession(function (err, session) {
                if (session) {

                    cognitoUser.verifyAttribute('email', that.state.codeForVerification, {
                        onSuccess: function (result) {
                            that.setState({
                                showVerificationCodeDialog: false,
                                showAlert: true,
                                alertStyle: 'success',
                                alertText: 'Your email address has been verified successfully'
                            });
                            let userObj = JSON.parse(localStorage.getItem('userObj'));
                            userObj.emailVerified = true;
                            localStorage.setItem('userObj', JSON.stringify(userObj));
                            dispatch({
                                type: 'SET_CURRENT_USER',
                                user: userObj
                            });
                            setTimeout(() => {
                                that.setState({ showAlert: false});
                            }, 5000);
                        },
                        onFailure: function (err) {
                            let errors = {};
                            errors.codeForVerification = err.message;
                            this.setState({errors});
                        }
                    });
                }
            });
        }
    }

    render() {

        let context = this;
        let data = this.props.studentPortal.dashboard.results;
        let logs = this.state.activityLog;
        return(
            <div>
                <span>{
                // <div className="searchCrtBar">
                // <div className="container-fluid">
                // <div className="row">
                // <div className="col-lg-6 col-md-6 col-xs-8">
                // <h3 style={{ fontWeight: "bold" , paddingTop : "15px"}}>{"Welcome back, " + this.props.auth.user.firstName+'!'}</h3>
                // </div>
                // </div>
                // </div>
                // </div>
                }
                </span>
                <div  className="container-fluid noPad listMainBoxWrapper">
                    <div id="submission"  className="tab-pane fade active in">
                        <div  className="quesAndIcon filterBlockss bordern" style={{background:'#f7f8fa', overflowX: 'hidden'}}>
                            <div  className="row xlxont">
                                <div  className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center grey-background" style={{paddingBottom: '50px'}}>
                                    {/*{!this.props.auth.user.emailVerified &&*/}
                                    {/*<WidgetAlert*/}
                                        {/*message="Reminder, your email address is not verified. You will not be able to reset your password if lost or forgotten."*/}
                                        {/*color="#fbf8e5"*/}
                                        {/*extraLink = {<a href='#' onClick={()=>{this.setState({showVerificationCodeDialog:true})}} >Verify Here</a>}*/}
                                        {/*// border="2px solid #f8ebcf"*/}
                                    {/*/>*/}
                                    {/*}*/}
                                    <WidgetOpenAssignments
                                        headinText = "Open Assignments"
                                        isFilterOnHeader={true}
                                        dataForFilter={this.state.allFilters}
                                        onFilterChangeHandler = {this.onFilterChangeHandler}
                                        filterPlaceHolder = 'Select Teacher'
                                        data={data}
                                        onClickViewAll={function () {
                                            browserHistory.push('/student/assignments')
                                        }}
                                        onSortingChangeHandler={function (evt) {

                                            let allData = context.props.studentPortal.dashboard.results;
                                            if (evt.target.value === 'dueDate')
                                            {
                                                allData.sort(function (a,b) {
                                                    return (new Date((parseFloat(a.dueDate)) - new Date((parseFloat(b.dueDate)))))
                                                });
                                            }
                                            else
                                            {
                                                allData.sort(function (a,b) {
                                                    return (new Date((parseFloat(b.createdAt)) - new Date((parseFloat(a.createdAt)))))
                                                });
                                            }
                                            let {dispatch}= context.props;
                                            dispatch({
                                                type: RECEIVED_STUDENT_ASSIGNMENT_DASHBOARD_RESULTS,
                                                data: JSON.parse(JSON.stringify(allData))
                                            });
                                        }}
                                    />
                                    {(this.props.appSettings.schoolType && this.props.appSettings.schoolType != 'Professional Learning') && <WidgetPractices
                                        headinText = "Practice"
                                        subjects = {this.state.subjects}
                                        onClickViewAll={function () {
                                            browserHistory.push('/student/selfstudy')
                                        }}
                                    />}


                                    <WidgetRegistration
                                    onRegistration={function(assignmentCount){


                                        if (assignmentCount > 0) {
                                            let message = "Please refresh the page momentarily as they will appear on your Student Dashboard under Open Assignments.";
                                            context.setState  ({ showDialog: true, dialogTitle: "You Have Open Assignments!", dialogMessage: message });
                                        }


                                        setTimeout(function () {
                                            context.getAllAssignments();
                                        }, 2000)

                                    }}
                                    />
                                    {logs && logs.length>0 && <WidgetActivityLog
                                        data = {logs}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showVerificationCodeDialog && this.getverificationCodeDialog()}
                {this.state.showAlert &&
                <div className="row">
                    <div className="col-md-3 col-xs-3"/>
                    <div className="col-md-6 col-xs-3">
                        <Alert bsStyle={this.state.alertStyle}
                               onDismiss={this.handleAlertDismiss}>
                            {this.state.alertText}
                        </Alert>
                    </div>
                    <div className="col-md-3 col-xs-3"/>
                </div>
                }

                {this.state.showDialog && this.getDialog()}
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {...state};
}

export default connect(mapStateToProps)(ManageDashboardStudent);
